import { render, staticRenderFns } from "./infoNarradores.vue?vue&type=template&id=e8d2dc28&scoped=true&"
import script from "./infoNarradores.vue?vue&type=script&lang=js&"
export * from "./infoNarradores.vue?vue&type=script&lang=js&"
import style0 from "./infoNarradores.vue?vue&type=style&index=0&id=e8d2dc28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d2dc28",
  null
  
)

export default component.exports